/**
 * The governance panel's body before readiness is evaluated: the workflow's
 * stages, then the readiness detail's toggle.
 *
 * @module components/governance/GovernanceBones
 */

import React from "react";

import { Bone } from "@/components/ui/SkeletonParts";

export function GovernanceBones(): React.ReactElement {
  return (
    <div aria-hidden="true" className="flex flex-col gap-6">
      <div className="flex items-start justify-between gap-2">
        {Array.from({ length: 6 }, (_, index) => (
          <div key={`stage-${String(index)}`} className="flex flex-1 flex-col items-center gap-2">
            <Bone className="size-6 rounded-full" />
            <Bone className="h-3 w-16" />
          </div>
        ))}
      </div>
      <Bone className="h-9 w-full" />
    </div>
  );
}
